/*
 * @Desc: 班级管理 接口
 * @Author: may.li
 * @Date: 2023-05-21 10:24:59
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-12-11 10:45:00
 */
import request from "@/utils/request";
const index = {
  // 列表
  list(query) {
    return request({
      url: "/wenjuan/list",
      method: "get",
      params: query
    });
  },
  // 新增
  create(data) {
    return request({
      url: "/wenjuan/create",
      method: "post",
      data
    });
  },
  // 编辑
  edit(data) {
    return request({
      url: "/wenjuan/edit",
      method: "post",
      data
    });
  },
  // 详情
  detail(query) {
    return request({
      url: "/wenjuan/detail",
      method: "post",
      params: query
    });
  },
  // 删除
  remove(data) {
    return request({
      url: "/wenjuan/remove",
      method: "post",
      data
    });
  },
  // 状态
  status(data) {
    return request({
      url: "/wenjuan/status",
      method: "post",
      data
    });
  },
  // 下拉选
  select(query) {
    return request({
      url: "/wenjuan/select",
      method: "get",
      params: query
    });
  },
};
export default index;
